function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M407.5,407.5 c-19.7,19.7-42.7,35.1-68.2,45.9c-26.4,11.3-54.5,16.8-83.5,16.8s-57.1-5.7-83.5-16.8c-25.5-10.8-48.5-26.3-68.2-45.9 c-19.7-19.7-35.1-42.7-45.9-68.2C47,313,41.5,284.9,41.5,255.9s5.7-57.1,16.8-83.5c10.8-25.5,26.3-48.5,45.9-68.2 s42.7-35.1,68.2-45.9c26.4-11.3,54.5-16.8,83.5-16.8s57.1,5.7,83.5,16.8c25.5,10.8,48.5,26.3,68.2,45.9 c19.7,19.7,35.1,42.7,45.9,68.2c11.3,26.4,16.8,54.5,16.8,83.5s-5.7,57.1-16.8,83.5C442.7,365,427.3,387.9,407.5,407.5z M342,232.5 c22.2,0,40-17.9,40-40s-17.9-40-40-40c-22.2,0-40,17.9-40,40S319.8,232.5,342,232.5z M170,232.5c22.2,0,40-17.9,40-40 s-17.9-40-40-40s-40,17.9-40,40S147.9,232.5,170,232.5z M381.7,292.1H130.3c-8.9,0-15.9,7.8-14.8,16.7 c8.2,66.1,64.7,117.3,133,117.3h14.9c68.4,0,124.8-51.2,133-117.3C397.6,300.1,390.6,292.1,381.7,292.1z M262.9,393.3h-13.6 c-42.8,0-79.7-28.4-91.6-68.3h196.9C342.6,364.9,305.7,393.3,262.9,393.3L262.9,393.3z"
});

function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.44a8963d.svg";
export { ForwardRef as ReactComponent };